/* src/app/user-default/state-update/state-update.component.scss */
.card-detail {
  margin: 0 20px;
  max-width: 42rem;
  padding-top: 0px;
}
a,
a:hover,
a:focus {
  color: inherit;
  transition: all 0.3s;
  text-decoration: underline;
}
/*# sourceMappingURL=state-update.component-CFLWJU4W.css.map */
